/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_Project_Hls_Manifest_PlaceholderInputs */

const en_new_project_hls_manifest_placeholder = /** @type {(inputs: New_Project_Hls_Manifest_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manifest URL`)
};

const fr_new_project_hls_manifest_placeholder = /** @type {(inputs: New_Project_Hls_Manifest_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL du manifeste`)
};

const de_new_project_hls_manifest_placeholder = /** @type {(inputs: New_Project_Hls_Manifest_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manifest-URL`)
};

const it_new_project_hls_manifest_placeholder = /** @type {(inputs: New_Project_Hls_Manifest_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL manifesto`)
};

const ru_new_project_hls_manifest_placeholder = /** @type {(inputs: New_Project_Hls_Manifest_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL манифеста`)
};

const es_new_project_hls_manifest_placeholder = /** @type {(inputs: New_Project_Hls_Manifest_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL del manifiesto`)
};

const zh_cn2_new_project_hls_manifest_placeholder = /** @type {(inputs: New_Project_Hls_Manifest_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`清单网址`)
};

const ja_new_project_hls_manifest_placeholder = /** @type {(inputs: New_Project_Hls_Manifest_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`マニフェストURL`)
};

const hi_new_project_hls_manifest_placeholder = /** @type {(inputs: New_Project_Hls_Manifest_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मैनिफेस्ट यूआरएल`)
};

const pt_pt2_new_project_hls_manifest_placeholder = /** @type {(inputs: New_Project_Hls_Manifest_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL do manifesto`)
};

/**
* | output |
* | --- |
* | "Manifest URL" |
*
* @param {New_Project_Hls_Manifest_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_project_hls_manifest_placeholder = /** @type {((inputs?: New_Project_Hls_Manifest_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_Project_Hls_Manifest_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_new_project_hls_manifest_placeholder(inputs)
	if (locale === "de") return de_new_project_hls_manifest_placeholder(inputs)
	if (locale === "it") return it_new_project_hls_manifest_placeholder(inputs)
	if (locale === "ru") return ru_new_project_hls_manifest_placeholder(inputs)
	if (locale === "es") return es_new_project_hls_manifest_placeholder(inputs)
	if (locale === "zh-CN") return zh_cn2_new_project_hls_manifest_placeholder(inputs)
	if (locale === "ja") return ja_new_project_hls_manifest_placeholder(inputs)
	if (locale === "hi") return hi_new_project_hls_manifest_placeholder(inputs)
	if (locale === "pt-PT") return pt_pt2_new_project_hls_manifest_placeholder(inputs)
	return en_new_project_hls_manifest_placeholder(inputs)
});